import React from 'react';

import { Box, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Button, Form } from 'gastro-ui-v3';
import { connect } from "react-redux";

import {
	// newPassword
} from "../actions";

const useStyles = makeStyles((theme) => ({
	action: {
		color: theme.palette.blue.dark,
		textAlign: 'right'
	},
	button: {
		marginBottom: theme.spacing(2),
		marginTop: theme.spacing(2),
	},
	form: {
		display: 'flex',
		flexDirection: 'column'
	},
	paper: {
		padding: theme.spacing(2, 2, 1, 2),
		maxWidth: 360,
		width: '100%'
	},
	root: {
  		alignItems: 'center',
    	background: `linear-gradient(160deg, ${theme.palette.green.main} 0%, ${theme.palette.blue.main} 100%)`,
    	display: 'flex',
    	flexDirection: 'column',
    	height: '100vh',
    	justifyContent: 'center'
	},
}));

function NewPasswordPage(props) {
	const classes = useStyles();

	const renderFormContent = (context) => {
		return (
			<div className={classes.form}>
				<Typography align="center" variant="h5" gutterBottom>
					New Password
				</Typography>

				<Form.Input
					autoFocus
					id="password"
					label="Password"
					type="password"
				/>

				<Button
					className={classes.button}
					color="green"
					disabled={ context.data.password.length < 6 }
					loading={ props.request.loading }
					size="large"
					type="submit"
				>
					Set new password
				</Button>
			</div>
		);
	}

    return (
        <Box className={classes.root}>
        	<Paper className={classes.paper}>
				<Form
					changes={false}
					fields={{
                        password: {},
						token: {
                            default: props.match.params.token
                        },
						tenant_id: {
							default: props.match.params.tenantId
						}
					}}
					request={props.request}
					onSubmit={data => props.newPassword(data)}
					topSave={false}
				>
					{ renderFormContent }
				</Form>
			</Paper>
        </Box>
    );
}

function mapStateToProps(state) {
	return {
		request: state.auth.request.newPassword
	}
}

export default connect(mapStateToProps, {
	// newPassword
})(NewPasswordPage);